import React from 'react';
import { UseQueryResult } from 'react-query';
import { match } from 'ts-pattern';
import { SuspendedPaymentsResponse } from '../../../api/payments';
import TableHeader from '../../../components/Table/TableHeader';
import SuspendedPaymentRow from './SuspendedPaymentRow';

interface Props {
  paymentsQuery: UseQueryResult<SuspendedPaymentsResponse, unknown>;
}

const tableColumns = [
  { key: null, label: 'Profilo' },
  { key: null, label: 'Email' },
  { key: null, label: 'Tipo prodotto' },
  { key: null, label: 'Order ID' },
  { key: null, label: 'Payment ID' },
  { key: null, label: 'Data e ora pagamento' },
  { key: null, label: 'Metodo pagamento' },
  { key: null, label: 'Stato' },
  { key: null, label: 'Importo' },
];

const SuspendedPaymentsTable: React.FC<Props> = ({ paymentsQuery }) => {
  return match(paymentsQuery)
    .with({ status: 'success' }, ({ data: response }) => (
      <div className='-my-2 overflow-x-auto'>
        <div className='inline-block min-w-full py-2 align-middle'>
          <div className='ring-1 border ring-black ring-opacity-5'>
            <table className='min-w-full table-fixed divide-y divide-gray-300'>
              <TableHeader columnsNames={tableColumns} />
              <tbody className='divide-y divide-gray-200 bg-white'>
                {response.data.length === 0 ? (
                  <tr>
                    <td
                      colSpan={tableColumns.length}
                      className='px-6 py-8 text-sm text-gray-400 text-center'
                    >
                      Nessun pagamento sospeso trovato
                    </td>
                  </tr>
                ) : (
                  response.data.map((order) => (
                    <SuspendedPaymentRow key={order.id} order={order} />
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    ))
    .with({ status: 'error' }, () => (
      <p>Errore caricamento pagamenti sospesi...</p>
    ))
    .with({ status: 'loading' }, { status: 'idle' }, () => (
      <p>Caricamento pagamenti sospesi...</p>
    ))
    .exhaustive();
};

export default SuspendedPaymentsTable;
